import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpClientBase } from './http-client-base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ParametrosService extends HttpClientBase {
  constructor(http: HttpClient) {
    super(http, 'parametros'); // La URL base para el servicio de usuarios
  }

  /** PLANTILLAS */
  getParametros(page: number, limit: number) {
    return this.get<any[]>({
      endpoint: `?page=${page}&limit=${limit}&pagination=true`,
      trackLoading: true, // 👈 loader
    });
  }

  addParametro(body: any): Observable<any> {
    return this.post<any>(body, '', undefined, true); // 👈 loader
  }

  updateParametro(body: any, parametro: string): Observable<any> {
    return this.put<any>(body, `${parametro}`, undefined, true); // 👈 loader
  }
}
